import React from "react";

import LinearProgress from "@mui/material/LinearProgress";

import { useStoreSelector } from "../../store/Hooks";
import InteractionShell from "../interactions/InteractionShell";

const Contents = () => {
  const rootInteractionID = useStoreSelector(
    (state) => state.interactionTree.RootInteractionID,
  );
  const interactionsLoaded = useStoreSelector(
    (state) => state.interactionTree.Loaded,
  );

  const showInteractions = interactionsLoaded && rootInteractionID > 0;

  if (showInteractions) {
    return (
      <div style={{ minHeight: "62vh" }}>
        <InteractionShell
          key={rootInteractionID}
          item={{}}
          rootInteractionID={rootInteractionID}
          interactionID={rootInteractionID}
        />
      </div>
    );
  } else {
    return (
      <div style={{ minHeight: "62vh" }} >
        <LinearProgress />
      </div>
    )
  }
};

export default Contents;
